import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1163 (integrations workspace).
// Contract: specs/_product/field-primitive-registry.md §1 ('locale_picker').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function LocalePicker(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="locale_picker" inputType="text" />;
}
